import { render, staticRenderFns } from "./ProjectTransfersListProject.vue?vue&type=template&id=412e5518"
import script from "./ProjectTransfersListProject.vue?vue&type=script&lang=js"
export * from "./ProjectTransfersListProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports